import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import Button from 'components/common/Button';
import UploadField from 'components/fields/UploadField';
import FormError from 'components/common/FormError';

import importFileTypes from 'config/importFileTypes';

import { importDataPortability } from 'redux/modules/dataPortability';

const styles = theme => ({
  error: {
    marginBottom: 16,
  },
  container: {
    display: 'flex',
    width: 390,
    minHeight: 310,
    padding: 20,
    boxSizing: 'border-box',
    borderRadius: 10,
    border: `1px solid ${theme.palette.primary.A400}`,
  },
});

function onSubmit(values, dispatch, props) {
  if (!values.File) {
    throw new SubmissionError({
      _error: 'No file selected',
    });
  }

  return new Promise((resolve, reject) => {
    dispatch(importDataPortability({
      values: {
        ID: props.ID,
        ...values,
      },
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

function onSubmitSuccess(values, dispatch, props) {
  props.reset();
}

function onChange(values, dispatch, props) {
  if (values.File) {
    dispatch(props.clearSubmitErrors());
  }
}

const DataImportForm = ({
  handleSubmit,
  submit,
  submitting,
  className,
  error,
  classes,
}) => (
  <form
    className={className}
    noValidate
    onSubmit={handleSubmit}
    autoComplete="off"
  >
    {error &&
      <FormError className={classes.error}>
        {error}
      </FormError>
    }
    <div className={classes.container}>
      <Grid
        container
        direction="column"
        alignItems="center"
        justify="center"
        spacing={40}
      >
        <Grid item>
          <Field
            id="File"
            name="File"
            component={UploadField}
            variant="import"
            label="Drag file here"
            loading={submitting}
            accept={importFileTypes}
            fullWidth
          />
        </Grid>
        <Grid>
          <Typography variant="caption">
            xls, xlsx, csv
          </Typography>
        </Grid>
        <Grid item>
          <Button
            variant="raised"
            color="primary"
            disabled={submitting}
            onClick={submit}
          >
            Upload File
          </Button>
        </Grid>
      </Grid>
    </div>
  </form>
);

DataImportForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  className: PropTypes.string,
  error: PropTypes.string,
  classes: PropTypes.shape({
    error: PropTypes.string.isRequired,
    container: PropTypes.string.isRequired,
  }).isRequired,
};

DataImportForm.defaultProps = {
  className: '',
  error: null,
};

export default reduxForm({
  onSubmit,
  onSubmitSuccess,
  onChange,
  form: 'dataPortabilityImport',
})(withStyles(styles)(DataImportForm));



// WEBPACK FOOTER //
// ./src/components/settings/DataPortability/DataPortabilityForm.js